<template>
<div>
  <div class="col-12 mb-primary">
    <div class="card card-with-shadow border-0 h-100">
      <app-overlay-loader v-if="preloader" />
      <div class="card-body">
        <div class="row">
          <div class="col-12" v-if="assign_user_id == userRole.id">
            <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
              <button
                type="button"
                class="btn btn-primary btn-with-shadow"
                data-toggle="modal"
                @click="openAddEditModal">
                {{ $t("add") }}
              </button>
              <br>
            </div>
          </div>
          <div class="col-6" v-if="assign_user_id == userRole.id">
            <div class="row">
              <div class="col-md-12 col-12">
                <label for="inputs_select_document">
                  {{ $t("select_documents") }}
                </label>
                <app-input
                  id="inputs_select_document"
                  type="multi-select"
                  :placeholder="$t('select_documents')"
                  :list="document"
                  v-model="documents"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button
                  type="button"
                  class="btn btn-primary mr-2 mt-2"
                  data-dismiss="modal"
                  @click.prevent="submit"
                >
                  {{ $t("submit") }}
                </button>
              </div>
            </div>
          </div>
          
          <div class="col-12">
            <div class="row" v-if="attach_documents.length > 0">
              <div class="col-sm-3 col-md-3" v-for="(document, index) in attach_documents" :key="index">
                <div class="card-body" style="padding: 1rem;">
                  <div class="card card-with-shadow border-0 ">
                    <div class="card-body text-center">
                      <span>
                        <app-icon name="file"/>
                      </span>
                      <h6 class="mt-2 text-center mb-0">
                        {{ document.name }}
                      </h6>
                      <small>Expiry: {{ document.expiry_date }}</small>
                    </div>
                  </div>
                </div>
                <div class="text-center my-2">
                  <a :href="document.file.path" download> Download </a><br>
                  <a v-if="assign_user_id == userRole.id" 
                  href="" @click.prevent="removeFile(document.id)"> Remove </a>
                </div>
              </div>
            </div>
              <app-empty-data-block v-if="attach_documents.length == 0" :message="$t('nothing_to_show_message')"/>
          </div>
        </div>
      </div>        
    </div>
  </div>
  <!--Delete Modal-->
    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="task-delete"
      @confirmed="confirmed"
      @cancelled="canceled"
    />

    <mydocument-addmodal
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />
</div>
  
</template>

<script>
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import {GET_ATTACH_MY_RECORD_DOCUMENT,TASK_ATTACH_DOCUMENT,GET_USER_ATTACH_DOCUMENT, TASK_ATTACH_DOCUMENT_DELETE} from "../../../../Config/ApiUrl";
import {
  axiosPost,
  axiosGet,
} from "../../../../Helpers/AxiosHelper";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  name: "mytaskmodal",
  mixins: [ModalMixin, FormMixin],
  // props: {
  //   tableId: String,
  //   id: Number,
  // },
  data() {
    return {
      document: [],
      attach_documents: [],
      documents: [],
      inputs: {},
      tableId: "advance-table",
      rowData: {},
      deleteLoader: false,
      deleteConfirmationModalActive: false,
      deletedDocId: 0,
      assign_user_id: 0,
      isAddEditModalActive: false,
    };
  },

  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.getDocument();
    },
    submit() {
      if (this.documents.length == 0) {
          this.$toastr.e('Select Document First');
      }
      else {
        this.inputs.task_id = this.$attrs["props"].id;
        this.inputs.document_id = this.documents;
        axiosPost(TASK_ATTACH_DOCUMENT, this.inputs)
          .then((res) => {
            this.$toastr.s(res.data.message);
            this.inputs = {};
            this.getAttachedDocument();
          })
          .catch((error) => {
            this.$toastr.e(error.data.message);
          });
        // this.save(this.inputs);
      }
    },
    afterSuccess(response) {
      this.$toastr.e(response.data.message);
      // this.$hub.$emit("reload-" + tableid.tableId);
    },

    getDocument() {
      let id = this.$attrs["props"];
      axiosGet(GET_ATTACH_MY_RECORD_DOCUMENT)
        .then((res) => {
          this.document = res.data;
        })
        .catch((error) => {
          
        });
    },
    getAttachedDocument() {
      let id = this.$attrs["props"];
      axiosGet(GET_USER_ATTACH_DOCUMENT + '/' + id.id)
        .then((res) => {
          
          this.attach_documents = res.data[0].task_documents;
          this.documents = res.data.selected_document;
          this.assign_user_id = res.data[0].taskable_id;
        })
        .catch((error) => {
          
        });
    },
    removeFile(doc_id) {
      this.deletedDocId = doc_id;
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      this.deleteLoader = true;
      let task_id = this.$attrs["props"].id;
      let deleteUrl = TASK_ATTACH_DOCUMENT_DELETE+'/'+this.deletedDocId+'?task_id='+task_id;
      this.axiosDelete(deleteUrl)
        .then((res) => {
          this.hideDeleteModal();
          this.$toastr.s(res.data.message);
          this.getAttachedDocument();
        })
        .catch((err) => {
          this.hideDeleteModal();
          this.$toastr.e(err.data.message);
        });
    },
    hideDeleteModal() {
      this.deleteLoader = false;
      $("#task-delete").modal("hide");
      this.canceled();
    },
    canceled() {
      this.deletedTaskId = null;
      this.deleteConfirmationModalActive = false;
    },
  }, 
  mounted() {
    this.getDocument();
    this.getAttachedDocument();
  },
  computed: {
    userRole() {
      
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
